import { store } from "modules/index";
import { getToken } from "modules/user/auth/selectors";

export default ({
  path,
  method,
  body,
  headers,
  config = {
    stringify: true
  }
}) => {
  return new Promise(async (resolve, reject) => {
    const initialHeaders = {
      apikey: getToken(store.getState()),
      "content-type": "application/json",
      "Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...headers
    };

    try {
      const response = await fetch(
        path[0] === "/" ? process.env.REACT_APP_API + path : path,
        {
          method,
          body: body && config.stringify ? JSON.stringify(body) : body,
          headers: !headers ? initialHeaders : headers(initialHeaders)
        }
      );
      const data = await response.text();

      if (response.status >= 400) {
        return reject({ data: JSON.parse(data) });
      }

      resolve(data && JSON.parse(data));
    } catch (err) {
      reject({ message: err.message });
    }
  });
};



// WEBPACK FOOTER //
// ./src/core/api/requestApi.js